// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"50\" cy=\"50\" r=\"2\" fill=\"%23ffffff\" fill-opacity=\"0.05\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Service Page - Complete Redesign */
.service-page-new {
  min-height: 100vh;
  background: #ffffff;
  overflow-x: hidden;
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.hero-section-no-video {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 50%, #1a1a2e 100%);
  background-size: 200% 200%;
  animation: gradientShift 15s ease infinite;
}

@keyframes gradientShift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.hero-video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.85) 0%, rgba(15, 52, 96, 0.75) 100%);
  z-index: 2;
}

.video-control-btn {
  position: absolute;
  bottom: 30px;
  right: 30px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  outline: none;
}

.video-control-btn:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.video-control-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1);
}

.hero-content {
  position: relative;
  z-index: 3;
  width: 100%;
  padding: 120px 20px 80px;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 40px;
  font-size: 14px;
  flex-wrap: wrap;
}

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb-link:hover {
  color: #4a9eff;
}

.breadcrumb-separator {
  color: rgba(255, 255, 255, 0.5);
}

.breadcrumb-current {
  color: #ffffff;
  font-weight: 600;
}

.hero-text {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.hero-title {
  font-size: clamp(2.5rem, 6vw, 5rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 25px;
  line-height: 1.2;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: fadeInUp 0.8s ease-out;
}

.hero-subtitle {
  font-size: clamp(1.1rem, 2vw, 1.5rem);
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.7;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.hero-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  animation: fadeInUp 1s ease-out 0.4s both;
}

.btn-primary-hero,
.btn-secondary-hero {
  padding: 16px 40px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.btn-primary-hero {
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  color: #ffffff;
  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.4);
}

.btn-primary-hero:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(74, 158, 255, 0.5);
}

.btn-secondary-hero {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.btn-secondary-hero:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-3px);
}

.scroll-down-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
}

.scroll-mouse {
  width: 30px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 25px;
  position: relative;
}

.scroll-mouse::before {
  content: '';
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: scrollBounce 2s infinite;
}

@keyframes scrollBounce {
  0%, 100% { transform: translateX(-50%) translateY(0); opacity: 1; }
  50% { transform: translateX(-50%) translateY(20px); opacity: 0.5; }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Statistics Section - Unique Class Names */
.service-page-stats-wrapper {
  padding: 80px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  width: 100%;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative;
  z-index: 1;
  min-height: 300px;
  overflow: visible;
}

.service-page-stats-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

.service-page-stats-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 40px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  visibility: visible !important;
  opacity: 1 !important;
}

.service-page-stat-card {
  text-align: center;
  padding: 40px 30px;
  background: #ffffff !important;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
  box-sizing: border-box;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative;
}

.service-page-stat-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(74, 158, 255, 0.15);
}

.service-page-stat-icon-box {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.service-page-stat-card:hover .service-page-stat-icon-box {
  transform: rotate(360deg) scale(1.1);
}

.service-page-stat-number {
  font-size: 3rem;
  font-weight: 800;
  color: #2c3e50 !important;
  margin-bottom: 10px;
  line-height: 1;
  display: block !important;
  width: 100%;
  visibility: visible !important;
  opacity: 1 !important;
}

.service-page-stat-description {
  font-size: 1rem;
  color: #666 !important;
  font-weight: 500;
  display: block !important;
  width: 100%;
  margin: 0;
  visibility: visible !important;
  opacity: 1 !important;
}

/* Content Tabs Section */
.content-tabs-section {
  padding: 100px 20px;
  background: #ffffff;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
}

.tabs-header {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 60px;
  flex-wrap: wrap;
  border-bottom: 2px solid #f0f0f0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 10px;
}

.tab-btn {
  padding: 15px 40px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 1.1rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  bottom: -2px;
  outline: none;
}

.tab-btn:focus {
  outline: 2px solid #4a9eff;
  outline-offset: 2px;
  border-radius: 4px;
}

.tab-btn:hover {
  color: #4a9eff;
}

.tab-btn.active {
  color: #4a9eff;
  border-bottom-color: #4a9eff;
}

.tabs-content {
  min-height: 400px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

.overview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.overview-content-single {
  grid-template-columns: 1fr;
  max-width: 900px;
}

.overview-text {
  width: 100%;
}

.overview-text h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
}

.overview-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 20px;
}

.overview-text p:last-child {
  margin-bottom: 0;
}

.overview-image {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.overview-image img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.6s ease;
}

.overview-image:hover img {
  transform: scale(1.05);
}

.features-grid-new {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card-new {
  background: #ffffff;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.feature-card-new::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(74, 158, 255, 0.1), transparent);
  transition: left 0.6s ease;
}

.feature-card-new:hover::before {
  left: 100%;
}

.feature-card-new:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(74, 158, 255, 0.2);
}

.feature-icon-new {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  transition: transform 0.3s ease;
}

.feature-card-new:hover .feature-icon-new {
  transform: rotate(360deg) scale(1.1);
}

.feature-number-new {
  font-size: 2rem;
  font-weight: 800;
  color: #ffffff;
}

.feature-title-new {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.5;
}

.benefits-grid-new {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  max-width: 1200px;
  margin: 0 auto;
}

.benefit-card-new {
  background: #ffffff;
  padding: 30px;
  border-radius: 15px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.benefit-card-new:hover {
  transform: translateX(10px);
  border-left-color: #4a9eff;
  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.15);
}

.benefit-check-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 20px;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.3);
}

.benefit-text-new {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #555;
  margin: 0;
  flex: 1 1;
}

/* Products Gallery Section */
.products-gallery-section {
  padding: 100px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  width: 100%;
  overflow: hidden;
}

.products-gallery-section .container {
  display: block;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  width: 100%;
  display: block;
}

.section-title-new {
  font-size: clamp(1.6rem, 4vw, 2.4rem);
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-title-new::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #666;
  margin-top: 20px;
  margin-bottom: 0;
  display: block;
}

.products-masonry {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  margin-top: 0;
}

.product-item {
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  min-width: 0;
}

.product-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2);
}

.product-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 75%;
  overflow: hidden;
  background: #f0f0f0;
}

.product-card-title {
  position: absolute;
  top: 18px;
  left: 18px;
  padding: 10px 18px;
  background: rgba(15, 52, 96, 0.85);
  color: #ffffff;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  box-shadow: 0 10px 25px rgba(15, 52, 96, 0.3);
  z-index: 2;
}

.other-service-item {
  text-decoration: none;
  color: inherit;
}

.other-service-slide {
  text-decoration: none;
  color: inherit;
  flex: 1 1;
}

.product-image-wrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.product-item:hover .product-image-wrapper img {
  transform: scale(1.15);
}

.product-hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 30px;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.product-item:hover .product-hover-overlay {
  opacity: 1;
}

.product-carousel {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  max-width: 430px;
  margin: 0 auto 40px;
}

.product-carousel-multi {
  max-width: none;
  gap: 24px;
  align-items: center;
  justify-content: center;
}

.product-carousel-track {
  display: flex;
  gap: 20px;
  width: 100%;
  flex: 1 1;
  overflow: hidden;
}

.product-carousel-multi .product-carousel-track {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(100% - 120px);
  justify-content: center;
  min-width: 0;
}

.product-carousel-card {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 20px);
  min-width: 180px;
  max-width: 100%;
  background: #fff;
}

.product-carousel-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(74, 158, 255, 0.2);
}

.product-carousel-slide {
  flex: 1 1;
  width: 100%;
  cursor: pointer;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
  background: #ffffff;
}

.carousel-arrow {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  color: #2c3e50;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
  flex: 0 0 46px;
}

.product-carousel-multi .carousel-arrow {
  align-self: center;
}

.carousel-arrow svg {
  stroke: currentColor;
}

.carousel-arrow:hover {
  transform: translateY(-2px);
  background: rgba(74, 158, 255, 0.12);
  color: #2c5aa0;
  box-shadow: 0 15px 35px rgba(74, 158, 255, 0.25);
}

.carousel-arrow:disabled {
  opacity: 0.4;
  cursor: default;
  transform: none;
  box-shadow: none;
}

.product-carousel-dots {
  position: absolute;
  bottom: -22px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.product-carousel-multi .product-carousel-dots {
  bottom: -32px;
  gap: 10px;
}

.product-carousel-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.15);
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.product-carousel-dot.active {
  width: 26px;
  border-radius: 999px;
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
}

.product-carousel-dot:hover {
  background: rgba(74, 158, 255, 0.45);
}

.view-product-btn {
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  color: #ffffff;
  border: none;
  padding: 14px 28px;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  outline: none;
}

.view-product-btn:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.view-product-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.5);
}

/* Image Modal */
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.modal-close {
  position: absolute;
  top: 30px;
  right: 30px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10001;
  outline: none;
}

.modal-close:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.modal-content {
  max-width: 90%;
  max-height: 90vh;
  position: relative;
  animation: scaleIn 0.3s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-content img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5);
}

/* CTA Section */
.cta-section-new {
  padding: 100px 20px;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: #ffffff;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.cta-section-new::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.cta-content-new {
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
}

.cta-title {
  font-size: clamp(2rem, 4vw, 3.5rem);
  font-weight: 700;
  margin-bottom: 20px;
}

.cta-description {
  font-size: 1.2rem;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.7;
}

.cta-buttons-new {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn-primary,
.cta-btn-secondary {
  padding: 18px 40px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
}

.cta-btn-primary {
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  color: #ffffff;
  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.4);
}

.cta-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(74, 158, 255, 0.5);
}

.cta-btn-secondary {
  background: transparent;
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.cta-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
}

/* Scroll Animation */
.fade-in-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-section.visible {
  opacity: 1;
  transform: translateY(0);
}

/* Ensure products are visible on small screens */
@media (max-width: 600px) {
  .products-gallery-section {
    opacity: 1 !important;
  }
  
  .products-masonry {
    opacity: 1 !important;
  }
  
  .product-item {
    opacity: 1 !important;
  }
}

/* Ensure tab panels are visible when active */
.tab-panel {
  display: none;
  min-height: 300px;
}

.tab-panel.tab-panel-active {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  animation: fadeInTab 0.5s ease;
  width: 100%;
}

@keyframes fadeInTab {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 3.5rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
  }

  .service-page-stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .overview-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .products-masonry {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 25px;
  }
}

@media (max-width: 600px) {
  .products-masonry {
    grid-template-columns: 1fr !important;
    gap: 20px;
  }

  .product-item {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .hero-section {
    min-height: 80vh;
  }

  .hero-content {
    padding: 100px 20px 60px;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .hero-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-primary-hero,
  .btn-secondary-hero {
    width: 100%;
    justify-content: center;
  }

  .video-control-btn {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }

  .service-page-stats-wrapper {
    padding: 60px 20px;
  }

  .service-page-stats-container {
    padding: 0 15px;
  }

  .service-page-stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .service-page-stat-card {
    padding: 30px 20px;
    min-height: 180px;
  }

  .service-page-stat-number {
    font-size: 2.5rem;
  }

  .content-tabs-section {
    padding: 60px 20px;
  }

  .tabs-header {
    flex-direction: column;
    border-bottom: none;
    gap: 0;
  }

  .tab-btn {
    width: 100%;
    border-bottom: 2px solid #f0f0f0;
    border-radius: 0;
    padding: 20px;
  }

  .tab-btn.active {
    border-bottom-color: #4a9eff;
    background: rgba(74, 158, 255, 0.05);
  }

  .features-grid-new {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .benefits-grid-new {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .products-gallery-section {
    padding: 60px 20px;
  }

  .products-gallery-section .container {
    padding: 0 15px;
  }

  .product-carousel {
    max-width: 100%;
    gap: 12px;
    margin-bottom: 55px;
  }

  .product-carousel-track {
    gap: 16px;
    width: 100%;
  }

  .product-carousel-multi .product-carousel-track {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 120px);
  }

  .product-carousel-multi .product-carousel-card {
    flex: 1 1 100%;
    min-width: 0;
    max-width: 100%;
  }

  .carousel-arrow {
    width: 42px;
    height: 42px;
  }

  .products-masonry {
    grid-template-columns: 1fr !important;
    gap: 20px;
    width: 100%;
    display: grid !important;
  }

  .product-item {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .cta-section-new {
    padding: 60px 20px;
  }

  .cta-buttons-new {
    flex-direction: column;
  }

  .cta-btn-primary,
  .cta-btn-secondary {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .hero-section {
    min-height: 70vh;
  }

  .hero-content {
    padding: 80px 15px 50px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .scroll-down-indicator {
    bottom: 20px;
  }

  .service-page-stats-wrapper {
    padding: 50px 15px;
  }

  .service-page-stats-container {
    padding: 0 10px;
  }

  .service-page-stats-grid {
    grid-template-columns: 1fr !important;
    gap: 20px;
  }

  .service-page-stat-card {
    padding: 25px 20px;
    min-height: 160px;
  }

  .service-page-stat-icon-box {
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }

  .service-page-stat-number {
    font-size: 2rem;
  }

  .service-page-stat-description {
    font-size: 0.9rem;
  }

  .content-tabs-section {
    padding: 50px 15px;
  }

  .section-title-new {
    font-size: 1.45rem;
  }

  .section-subtitle {
    font-size: 0.95rem;
  }

  .overview-content,
  .overview-content-single {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .overview-text h2 {
    font-size: 1.8rem;
  }

  .overview-text p {
    font-size: 1rem;
  }

  .feature-card-new {
    padding: 30px 20px;
  }

  .feature-icon-new {
    width: 70px;
    height: 70px;
  }

  .feature-number-new {
    font-size: 1.8rem;
  }

  .benefit-card-new {
    padding: 25px 20px;
    gap: 15px;
  }

  .benefit-check-icon {
    width: 35px;
    height: 35px;
    font-size: 18px;
  }

  .products-gallery-section {
    padding: 50px 15px;
  }

  .product-carousel {
    margin-bottom: 50px;
  }

  .product-carousel-track {
    gap: 20px;
  }

  .product-carousel-multi .product-carousel-card {
    flex: 1 1 100%;
    min-width: 0;
  }

  .products-gallery-section .container {
    padding: 0 10px;
    width: 100%;
  }

  .section-header {
    margin-bottom: 40px;
  }

  .products-masonry {
    grid-template-columns: 1fr !important;
    gap: 15px;
    width: 100%;
    display: grid !important;
  }

  .product-item {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    min-width: 0 !important;
  }

  .product-image-wrapper {
    padding-top: 75%;
    width: 100%;
  }

  .product-image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .product-hover-overlay {
    padding: 20px;
  }

  .view-product-btn {
    padding: 12px 24px;
    font-size: 0.9rem;
  }

  .modal-close {
    top: 15px;
    right: 15px;
    width: 40px;
    height: 40px;
  }

  .cta-section-new {
    padding: 50px 15px;
  }

  .cta-title {
    font-size: 1.8rem;
  }

  .cta-description {
    font-size: 1rem;
  }

  .cta-btn-primary,
  .cta-btn-secondary {
    padding: 15px 30px;
    font-size: 1rem;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

.products-gallery-section .container {
  width: 100%;
  max-width: 100%;
  padding: 0 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServicePage/ServicePage.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,0EAA0E;EAC1E,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,WAAW,2BAA2B,EAAE;EACxC,MAAM,6BAA6B,EAAE;AACvC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2FAA2F;EAC3F,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,WAAW,yCAAyC,EAAE,UAAU,EAAE;EAClE,MAAM,4CAA4C,EAAE,YAAY,EAAE;AACpE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,iDAAiD;EACjD,qCAAqC;EACrC,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,0CAA0C;EAC1C,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,SAAO;AACT;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qGAAqG;EACrG,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAA4B;EAA5B,cAA4B;EAA5B,8BAA4B;EAC5B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAuM;AACzM;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,MAAM;EACR;;EAEA;IACE,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Modern Service Page - Complete Redesign */\n.service-page-new {\n  min-height: 100vh;\n  background: #ffffff;\n  overflow-x: hidden;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n}\n\n.hero-section-no-video {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 50%, #1a1a2e 100%);\n  background-size: 200% 200%;\n  animation: gradientShift 15s ease infinite;\n}\n\n@keyframes gradientShift {\n  0%, 100% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n}\n\n.hero-video-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.hero-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.hero-video-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(26, 26, 46, 0.85) 0%, rgba(15, 52, 96, 0.75) 100%);\n  z-index: 2;\n}\n\n.video-control-btn {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  outline: none;\n}\n\n.video-control-btn:focus {\n  outline: 2px solid rgba(255, 255, 255, 0.5);\n  outline-offset: 2px;\n}\n\n.video-control-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: scale(1.1);\n}\n\n.hero-content {\n  position: relative;\n  z-index: 3;\n  width: 100%;\n  padding: 120px 20px 80px;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 40px;\n  font-size: 14px;\n  flex-wrap: wrap;\n}\n\n.breadcrumb-link {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.breadcrumb-link:hover {\n  color: #4a9eff;\n}\n\n.breadcrumb-separator {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.breadcrumb-current {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.hero-text {\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.hero-title {\n  font-size: clamp(2.5rem, 6vw, 5rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 25px;\n  line-height: 1.2;\n  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.hero-subtitle {\n  font-size: clamp(1.1rem, 2vw, 1.5rem);\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.7;\n  margin-bottom: 40px;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  flex-wrap: wrap;\n  animation: fadeInUp 1s ease-out 0.4s both;\n}\n\n.btn-primary-hero,\n.btn-secondary-hero {\n  padding: 16px 40px;\n  border-radius: 50px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.btn-primary-hero {\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  color: #ffffff;\n  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.4);\n}\n\n.btn-primary-hero:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 15px 40px rgba(74, 158, 255, 0.5);\n}\n\n.btn-secondary-hero {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.btn-secondary-hero:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-3px);\n}\n\n.scroll-down-indicator {\n  position: absolute;\n  bottom: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 3;\n}\n\n.scroll-mouse {\n  width: 30px;\n  height: 50px;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  border-radius: 25px;\n  position: relative;\n}\n\n.scroll-mouse::before {\n  content: '';\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 6px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  animation: scrollBounce 2s infinite;\n}\n\n@keyframes scrollBounce {\n  0%, 100% { transform: translateX(-50%) translateY(0); opacity: 1; }\n  50% { transform: translateX(-50%) translateY(20px); opacity: 0.5; }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Statistics Section - Unique Class Names */\n.service-page-stats-wrapper {\n  padding: 80px 20px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  width: 100%;\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  position: relative;\n  z-index: 1;\n  min-height: 300px;\n  overflow: visible;\n}\n\n.service-page-stats-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.service-page-stats-grid {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 40px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.service-page-stat-card {\n  text-align: center;\n  padding: 40px 30px;\n  background: #ffffff !important;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  width: 100%;\n  box-sizing: border-box;\n  visibility: visible !important;\n  opacity: 1 !important;\n  position: relative;\n}\n\n.service-page-stat-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 60px rgba(74, 158, 255, 0.15);\n}\n\n.service-page-stat-icon-box {\n  width: 70px;\n  height: 70px;\n  margin: 0 auto 20px;\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n.service-page-stat-card:hover .service-page-stat-icon-box {\n  transform: rotate(360deg) scale(1.1);\n}\n\n.service-page-stat-number {\n  font-size: 3rem;\n  font-weight: 800;\n  color: #2c3e50 !important;\n  margin-bottom: 10px;\n  line-height: 1;\n  display: block !important;\n  width: 100%;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.service-page-stat-description {\n  font-size: 1rem;\n  color: #666 !important;\n  font-weight: 500;\n  display: block !important;\n  width: 100%;\n  margin: 0;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* Content Tabs Section */\n.content-tabs-section {\n  padding: 100px 20px;\n  background: #ffffff;\n  min-height: 60vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabs-header {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 60px;\n  flex-wrap: wrap;\n  border-bottom: 2px solid #f0f0f0;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 10px;\n}\n\n.tab-btn {\n  padding: 15px 40px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  bottom: -2px;\n  outline: none;\n}\n\n.tab-btn:focus {\n  outline: 2px solid #4a9eff;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.tab-btn:hover {\n  color: #4a9eff;\n}\n\n.tab-btn.active {\n  color: #4a9eff;\n  border-bottom-color: #4a9eff;\n}\n\n.tabs-content {\n  min-height: 400px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.overview-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.overview-content-single {\n  grid-template-columns: 1fr;\n  max-width: 900px;\n}\n\n.overview-text {\n  width: 100%;\n}\n\n.overview-text h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin-bottom: 20px;\n}\n\n.overview-text p {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.overview-text p:last-child {\n  margin-bottom: 0;\n}\n\n.overview-image {\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n.overview-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  transition: transform 0.6s ease;\n}\n\n.overview-image:hover img {\n  transform: scale(1.05);\n}\n\n.features-grid-new {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.feature-card-new {\n  background: #ffffff;\n  padding: 40px 30px;\n  border-radius: 20px;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  transition: all 0.4s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n}\n\n.feature-card-new::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(74, 158, 255, 0.1), transparent);\n  transition: left 0.6s ease;\n}\n\n.feature-card-new:hover::before {\n  left: 100%;\n}\n\n.feature-card-new:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 50px rgba(74, 158, 255, 0.2);\n}\n\n.feature-icon-new {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 25px;\n  transition: transform 0.3s ease;\n}\n\n.feature-card-new:hover .feature-icon-new {\n  transform: rotate(360deg) scale(1.1);\n}\n\n.feature-number-new {\n  font-size: 2rem;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.feature-title-new {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #2c3e50;\n  line-height: 1.5;\n}\n\n.benefits-grid-new {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 25px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.benefit-card-new {\n  background: #ffffff;\n  padding: 30px;\n  border-radius: 15px;\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  border-left: 4px solid transparent;\n}\n\n.benefit-card-new:hover {\n  transform: translateX(10px);\n  border-left-color: #4a9eff;\n  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.15);\n}\n\n.benefit-check-icon {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 20px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.3);\n}\n\n.benefit-text-new {\n  font-size: 1.05rem;\n  line-height: 1.7;\n  color: #555;\n  margin: 0;\n  flex: 1;\n}\n\n/* Products Gallery Section */\n.products-gallery-section {\n  padding: 100px 20px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  width: 100%;\n  overflow: hidden;\n}\n\n.products-gallery-section .container {\n  display: block;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 60px;\n  width: 100%;\n  display: block;\n}\n\n.section-title-new {\n  font-size: clamp(1.6rem, 4vw, 2.4rem);\n  font-weight: 700;\n  color: #2c3e50;\n  margin-bottom: 15px;\n  position: relative;\n  display: inline-block;\n}\n\n.section-title-new::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  border-radius: 2px;\n}\n\n.section-subtitle {\n  font-size: 1.1rem;\n  color: #666;\n  margin-top: 20px;\n  margin-bottom: 0;\n  display: block;\n}\n\n.products-masonry {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 30px;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  margin-top: 0;\n}\n\n.product-item {\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.4s ease;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  min-width: 0;\n}\n\n.product-item:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2);\n}\n\n.product-image-wrapper {\n  position: relative;\n  width: 100%;\n  padding-top: 75%;\n  overflow: hidden;\n  background: #f0f0f0;\n}\n\n.product-card-title {\n  position: absolute;\n  top: 18px;\n  left: 18px;\n  padding: 10px 18px;\n  background: rgba(15, 52, 96, 0.85);\n  color: #ffffff;\n  font-weight: 600;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  box-shadow: 0 10px 25px rgba(15, 52, 96, 0.3);\n  z-index: 2;\n}\n\n.other-service-item {\n  text-decoration: none;\n  color: inherit;\n}\n\n.other-service-slide {\n  text-decoration: none;\n  color: inherit;\n  flex: 1;\n}\n\n.product-image-wrapper img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s ease;\n}\n\n.product-item:hover .product-image-wrapper img {\n  transform: scale(1.15);\n}\n\n.product-hover-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 100%);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 30px;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n.product-item:hover .product-hover-overlay {\n  opacity: 1;\n}\n\n.product-carousel {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  width: 100%;\n  max-width: 430px;\n  margin: 0 auto 40px;\n}\n\n.product-carousel-multi {\n  max-width: none;\n  gap: 24px;\n  align-items: center;\n  justify-content: center;\n}\n\n.product-carousel-track {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  flex: 1;\n  overflow: hidden;\n}\n\n.product-carousel-multi .product-carousel-track {\n  flex: 1 1 calc(100% - 120px);\n  justify-content: center;\n  min-width: 0;\n}\n\n.product-carousel-card {\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  transition: all 0.4s ease;\n  flex: 1 1 calc(25% - 20px);\n  min-width: 180px;\n  max-width: 100%;\n  background: #fff;\n}\n\n.product-carousel-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 50px rgba(74, 158, 255, 0.2);\n}\n\n.product-carousel-slide {\n  flex: 1;\n  width: 100%;\n  cursor: pointer;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);\n  background: #ffffff;\n}\n\n.carousel-arrow {\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  color: #2c3e50;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;\n  flex: 0 0 46px;\n}\n\n.product-carousel-multi .carousel-arrow {\n  align-self: center;\n}\n\n.carousel-arrow svg {\n  stroke: currentColor;\n}\n\n.carousel-arrow:hover {\n  transform: translateY(-2px);\n  background: rgba(74, 158, 255, 0.12);\n  color: #2c5aa0;\n  box-shadow: 0 15px 35px rgba(74, 158, 255, 0.25);\n}\n\n.carousel-arrow:disabled {\n  opacity: 0.4;\n  cursor: default;\n  transform: none;\n  box-shadow: none;\n}\n\n.product-carousel-dots {\n  position: absolute;\n  bottom: -22px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 8px;\n}\n\n.product-carousel-multi .product-carousel-dots {\n  bottom: -32px;\n  gap: 10px;\n}\n\n.product-carousel-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.15);\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.product-carousel-dot.active {\n  width: 26px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n}\n\n.product-carousel-dot:hover {\n  background: rgba(74, 158, 255, 0.45);\n}\n\n.view-product-btn {\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  color: #ffffff;\n  border: none;\n  padding: 14px 28px;\n  border-radius: 30px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n  outline: none;\n}\n\n.view-product-btn:focus {\n  outline: 2px solid rgba(255, 255, 255, 0.5);\n  outline-offset: 2px;\n}\n\n.view-product-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.5);\n}\n\n/* Image Modal */\n.image-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.95);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n.modal-close {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10001;\n  outline: none;\n}\n\n.modal-close:focus {\n  outline: 2px solid rgba(255, 255, 255, 0.5);\n  outline-offset: 2px;\n}\n\n.modal-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: rotate(90deg);\n}\n\n.modal-content {\n  max-width: 90%;\n  max-height: 90vh;\n  position: relative;\n  animation: scaleIn 0.3s ease;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.modal-content img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5);\n}\n\n/* CTA Section */\n.cta-section-new {\n  padding: 100px 20px;\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  color: #ffffff;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.cta-section-new::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"50\" cy=\"50\" r=\"2\" fill=\"%23ffffff\" fill-opacity=\"0.05\"/></svg>');\n}\n\n.cta-content-new {\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.cta-title {\n  font-size: clamp(2rem, 4vw, 3.5rem);\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.cta-description {\n  font-size: 1.2rem;\n  margin-bottom: 40px;\n  opacity: 0.9;\n  line-height: 1.7;\n}\n\n.cta-buttons-new {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.cta-btn-primary,\n.cta-btn-secondary {\n  padding: 18px 40px;\n  border-radius: 50px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n}\n\n.cta-btn-primary {\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  color: #ffffff;\n  box-shadow: 0 10px 30px rgba(74, 158, 255, 0.4);\n}\n\n.cta-btn-primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 15px 40px rgba(74, 158, 255, 0.5);\n}\n\n.cta-btn-secondary {\n  background: transparent;\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.cta-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-3px);\n}\n\n/* Scroll Animation */\n.fade-in-section {\n  opacity: 0;\n  transform: translateY(50px);\n  transition: opacity 0.8s ease-out, transform 0.8s ease-out;\n}\n\n.fade-in-section.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Ensure products are visible on small screens */\n@media (max-width: 600px) {\n  .products-gallery-section {\n    opacity: 1 !important;\n  }\n  \n  .products-masonry {\n    opacity: 1 !important;\n  }\n  \n  .product-item {\n    opacity: 1 !important;\n  }\n}\n\n/* Ensure tab panels are visible when active */\n.tab-panel {\n  display: none;\n  min-height: 300px;\n}\n\n.tab-panel.tab-panel-active {\n  display: block !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  animation: fadeInTab 0.5s ease;\n  width: 100%;\n}\n\n@keyframes fadeInTab {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .hero-title {\n    font-size: 3.5rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1.3rem;\n  }\n\n  .service-page-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n  }\n\n  .overview-content {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n\n  .products-masonry {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 25px;\n  }\n}\n\n@media (max-width: 600px) {\n  .products-masonry {\n    grid-template-columns: 1fr !important;\n    gap: 20px;\n  }\n\n  .product-item {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-section {\n    min-height: 80vh;\n  }\n\n  .hero-content {\n    padding: 100px 20px 60px;\n  }\n\n  .hero-title {\n    font-size: 2.5rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1.1rem;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .btn-primary-hero,\n  .btn-secondary-hero {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .video-control-btn {\n    bottom: 20px;\n    right: 20px;\n    width: 45px;\n    height: 45px;\n  }\n\n  .service-page-stats-wrapper {\n    padding: 60px 20px;\n  }\n\n  .service-page-stats-container {\n    padding: 0 15px;\n  }\n\n  .service-page-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n\n  .service-page-stat-card {\n    padding: 30px 20px;\n    min-height: 180px;\n  }\n\n  .service-page-stat-number {\n    font-size: 2.5rem;\n  }\n\n  .content-tabs-section {\n    padding: 60px 20px;\n  }\n\n  .tabs-header {\n    flex-direction: column;\n    border-bottom: none;\n    gap: 0;\n  }\n\n  .tab-btn {\n    width: 100%;\n    border-bottom: 2px solid #f0f0f0;\n    border-radius: 0;\n    padding: 20px;\n  }\n\n  .tab-btn.active {\n    border-bottom-color: #4a9eff;\n    background: rgba(74, 158, 255, 0.05);\n  }\n\n  .features-grid-new {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .benefits-grid-new {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .products-gallery-section {\n    padding: 60px 20px;\n  }\n\n  .products-gallery-section .container {\n    padding: 0 15px;\n  }\n\n  .product-carousel {\n    max-width: 100%;\n    gap: 12px;\n    margin-bottom: 55px;\n  }\n\n  .product-carousel-track {\n    gap: 16px;\n    width: 100%;\n  }\n\n  .product-carousel-multi .product-carousel-track {\n    flex: 1 1 calc(100% - 120px);\n  }\n\n  .product-carousel-multi .product-carousel-card {\n    flex: 1 1 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .carousel-arrow {\n    width: 42px;\n    height: 42px;\n  }\n\n  .products-masonry {\n    grid-template-columns: 1fr !important;\n    gap: 20px;\n    width: 100%;\n    display: grid !important;\n  }\n\n  .product-item {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n  }\n\n  .cta-section-new {\n    padding: 60px 20px;\n  }\n\n  .cta-buttons-new {\n    flex-direction: column;\n  }\n\n  .cta-btn-primary,\n  .cta-btn-secondary {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-section {\n    min-height: 70vh;\n  }\n\n  .hero-content {\n    padding: 80px 15px 50px;\n  }\n\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .scroll-down-indicator {\n    bottom: 20px;\n  }\n\n  .service-page-stats-wrapper {\n    padding: 50px 15px;\n  }\n\n  .service-page-stats-container {\n    padding: 0 10px;\n  }\n\n  .service-page-stats-grid {\n    grid-template-columns: 1fr !important;\n    gap: 20px;\n  }\n\n  .service-page-stat-card {\n    padding: 25px 20px;\n    min-height: 160px;\n  }\n\n  .service-page-stat-icon-box {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 15px;\n  }\n\n  .service-page-stat-number {\n    font-size: 2rem;\n  }\n\n  .service-page-stat-description {\n    font-size: 0.9rem;\n  }\n\n  .content-tabs-section {\n    padding: 50px 15px;\n  }\n\n  .section-title-new {\n    font-size: 1.45rem;\n  }\n\n  .section-subtitle {\n    font-size: 0.95rem;\n  }\n\n  .overview-content,\n  .overview-content-single {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n\n  .overview-text h2 {\n    font-size: 1.8rem;\n  }\n\n  .overview-text p {\n    font-size: 1rem;\n  }\n\n  .feature-card-new {\n    padding: 30px 20px;\n  }\n\n  .feature-icon-new {\n    width: 70px;\n    height: 70px;\n  }\n\n  .feature-number-new {\n    font-size: 1.8rem;\n  }\n\n  .benefit-card-new {\n    padding: 25px 20px;\n    gap: 15px;\n  }\n\n  .benefit-check-icon {\n    width: 35px;\n    height: 35px;\n    font-size: 18px;\n  }\n\n  .products-gallery-section {\n    padding: 50px 15px;\n  }\n\n  .product-carousel {\n    margin-bottom: 50px;\n  }\n\n  .product-carousel-track {\n    gap: 20px;\n  }\n\n  .product-carousel-multi .product-carousel-card {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .products-gallery-section .container {\n    padding: 0 10px;\n    width: 100%;\n  }\n\n  .section-header {\n    margin-bottom: 40px;\n  }\n\n  .products-masonry {\n    grid-template-columns: 1fr !important;\n    gap: 15px;\n    width: 100%;\n    display: grid !important;\n  }\n\n  .product-item {\n    width: 100% !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    min-width: 0 !important;\n  }\n\n  .product-image-wrapper {\n    padding-top: 75%;\n    width: 100%;\n  }\n\n  .product-image-wrapper img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n\n  .product-hover-overlay {\n    padding: 20px;\n  }\n\n  .view-product-btn {\n    padding: 12px 24px;\n    font-size: 0.9rem;\n  }\n\n  .modal-close {\n    top: 15px;\n    right: 15px;\n    width: 40px;\n    height: 40px;\n  }\n\n  .cta-section-new {\n    padding: 50px 15px;\n  }\n\n  .cta-title {\n    font-size: 1.8rem;\n  }\n\n  .cta-description {\n    font-size: 1rem;\n  }\n\n  .cta-btn-primary,\n  .cta-btn-secondary {\n    padding: 15px 30px;\n    font-size: 1rem;\n  }\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.products-gallery-section .container {\n  width: 100%;\n  max-width: 100%;\n  padding: 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
